
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/grafinis-dizainas",
      function () {
        return require("private-next-pages/lt/grafinis-dizainas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/grafinis-dizainas"])
      });
    }
  